import { TFunction } from '@spotify-internal/i18n-core';
import { ArtistRole } from '@hooks/useAlbumInfo/types';

export const getArtistTranslationKey = (
  artistRole: ArtistRole,
  t: TFunction,
) => {
  switch (artistRole) {
    case ArtistRole.FEATURED_ARTIST:
      return t(
        'atlas.labels.roles.featured_artist',
        'Featured artist',
        'A type of artist role',
      );
    case ArtistRole.REMIXER:
      return t(
        'atlas.labels.roles.remixer',
        'Remixer',
        'A type of artist role',
      );
    default:
      return t(
        'atlas.labels.roles.main_artist',
        'Main artist',
        'A type of artist role',
      );
  }
};
